import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f3aa42"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "video-container"
}
const _hoisted_2 = ["loop", "src"]
const _hoisted_3 = {
  key: 0,
  class: "center",
  style: {"font-size":"40px"}
}
const _hoisted_4 = {
  key: 1,
  class: "center",
  style: {"font-size":"40px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"40px"} }, "Scan to cast NFTs", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 0,
          active: true
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.token)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.media_is_video)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("video", {
                        class: _normalizeClass([_ctx.show_video ? 'show-opacity' : 'hide-opacity', "center"]),
                        ref: "player",
                        autoplay: "",
                        muted: "",
                        loop: _ctx.video_should_loop,
                        src: _ctx.media_url
                      }, null, 10, _hoisted_2)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.loading && !_ctx.token)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.display?.entity?.account_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Connected - No token selected"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_qrcode_vue, {
                        value: _ctx.display_controller_url,
                        size: 300,
                        level: 'H'
                      }, null, 8, ["value"]),
                      _hoisted_5
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}